import API from '../../apiConfig';

export const sendOTP = async (data) => {
  const response = await API.postWithoutToken('user/supplier/sendOTP', data);
  return response;
};

export const resendOTP = async (data) => {
  const response = await API.postWithoutToken('user/supplier/resendOTP', data);
  return response;
};

export const verifyOTP = async (data) => {
  const response = await API.postWithoutToken('user/supplier/verifyOTP', data);
  return response;
};

export const getUserJourney = async (supplierId) => {
  const response = await API.get(
    'supplier/journey-details',
    supplierId ? { params: { supplier_id: supplierId } } : {}
  );
  return response;
};

export const getCategories = async () => {
  const response = await API.getWithoutToken('supplier/reg/category-list');
  return response;
};

export const getRecommendedProducts = async (data) => {
  const response = await API.get('supplier/recommended_asn', { params: data });
  return response;
};
